import { baseUrl } from '@/components/utils/browser/url';
import { PORTFOLIO_PAGE_PATH } from '@/constants/pages';

export const getPortfolioPath = (userSlug: string) => `${PORTFOLIO_PAGE_PATH}${userSlug}`;
export const getPortfolioUrl = (userSlug: string) => {
  const { host } = new URL(baseUrl());

  return `${host}${getPortfolioPath(userSlug)}`;
};
export const getUniversityPath = (universitySlug: string) => `/universities/${universitySlug}`;
